// state that we store for each chat session that we want to persist even after session switching
// for example, if we switch from session A to session B and then back to session A, we want to remember what the input was.
export interface ChatUiSessionState {
    selectedTab?: string;
    draftInput?: string;
    isLoadingMessages?: boolean;
    isUploadingDocuments?: boolean;
    isBulkUploadProcessing?: boolean;
    bulkUploadFileName?: string;
    modelType?: number;
    selectedAgents?: string[];
    thinkLonger?: boolean;
    isResponseGenerating?: boolean;
    isTitleGenerating?: boolean;
    streamingMessageId?: string;
    bulkStatusMessageId?: string;
    botResponseStatus?: string;
    pptxExportingMessageIds?: string[];
    hasMoreMessages?: boolean;
    loadedMessageCount?: number;
}

export interface ChatUiState {
    selectedSessionId: string | null;
    bySessionId: Record<string, ChatUiSessionState>;
    canvasOpen: boolean;
}

export const emptyChatUiSessionState: ChatUiSessionState = {};

export const initialChatUiState: ChatUiState = {
    selectedSessionId: null,
    bySessionId: {},
    canvasOpen: false,
};
